import React, { useState, useEffect } from "react";
import axios from "axios";
import { Utensils, Heart, Award } from "lucide-react";
import { restaurant, aboutImages } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import SectionBg from "./SectionBg";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function About() {
  const { t } = useLang();
  const [images, setImages] = useState(aboutImages);

  useEffect(() => {
    axios.get(`${API}/about-images`)
      .then((res) => { if (res.data && res.data.main) setImages(res.data); })
      .catch(() => {});
  }, []);

  const pillars = [
    { icon: Award, title: t("about.pillar1"), sub: t("about.pillar1s") },
    { icon: Heart, title: t("about.pillar2"), sub: t("about.pillar2s") },
    { icon: Utensils, title: t("about.pillar3"), sub: t("about.pillar3s") },
  ];

  return (
    <section id="chisiamo" className="relative py-24 md:py-32 bg-[#FBF7F0] overflow-hidden">
      <SectionBg section="about" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="relative reveal">
            <div className="relative rounded-[2px] overflow-hidden shadow-2xl">
              <img src={images.main} alt="Restaurant interior" className="w-full h-[520px] object-cover" />
            </div>
            <div className="absolute -bottom-8 -right-4 md:-right-8 w-44 h-56 md:w-56 md:h-64 rounded-[2px] overflow-hidden shadow-2xl border-4 border-[#FBF7F0] floaty">
              <img src={images.accent} alt="Gourmet dish" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -top-6 -left-4 bg-[#1C1815] text-white px-7 py-5 rounded-[2px] shadow-xl hidden md:block">
              <p className="font-display text-3xl text-[#C9A24B]">{restaurant.experience}</p>
              <p className="text-xs tracking-widest uppercase text-white/70">{t("about.years")}</p>
            </div>
          </div>

          <div className="reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#C9A24B]" />
              <span className="text-[#B0863B] tracking-[0.3em] text-xs uppercase">{t("about.badge")}</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-[#23201C] leading-tight mb-7">
              {t("about.title1")}<br />
              <span className="italic text-[#C9A24B]">{t("about.highlight")}</span>
            </h2>
            <p className="text-[#5a5347] text-lg leading-relaxed mb-6">{t("about.p1")}</p>
            <p className="text-[#5a5347] text-lg leading-relaxed mb-10">{t("about.p2")}</p>

            <div className="grid grid-cols-3 gap-4">
              {pillars.map((p) => (
                <div key={p.title} className="group text-center bg-white rounded-[2px] p-5 border border-[#efe6d4] shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <p.icon className="mx-auto mb-3 text-[#C9A24B]" size={26} strokeWidth={1.5} />
                  <p className="font-display text-lg text-[#23201C]">{p.title}</p>
                  <p className="text-xs text-[#8a7f6b] mt-1">{p.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}